// extracted by mini-css-extract-plugin
export default {"promptMessage":"_3XVcSLhnCO2kzQfXT2NVMh"};